import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ProfileGroupOptionComponent } from '../group-option/profile-group-option.component';
import { NProfiles } from '../profile.interfaces';
import { ProfileSizeOptionsComponent } from '../size-options/profile-size-options.component';

@Component({
    selector: 'profile-size-selector',
    templateUrl: './profile-size-selector.component.html',
    styleUrls: ['./profile-size-selector.component.scss'],
    standalone: true,
    imports: [TranslationModule, ProfileSizeOptionsComponent, ProfileGroupOptionComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfileSizeSelectorComponent extends UiComponent implements OnChanges {
    @Input()
    sizeGroups: NProfiles.ISizeGroup[] = [];
    @Input()
    title?: string;
    @Input()
    selectedGroup?: NProfiles.ESizeGroup;
    @Input()
    selectedSizes: { [key: string]: number[] } = {};
    @Output()
    selectedGroupChange = new EventEmitter<NProfiles.ESizeGroup | undefined>();
    @Output()
    selectedSizesChange = new EventEmitter<{ [key: string]: number[] }>();

    protected ESizeGroup = NProfiles.ESizeGroup;

    protected selectGroup(group: NProfiles.ESizeGroup): void {
        // Clear previous size selections when changing group
        const newSizes = {};
        this.selectedGroupChange.emit(group);
        this.selectedSizesChange.emit(newSizes);
    }

    protected isGroupSelected(group: NProfiles.ESizeGroup): boolean {
        return this.selectedGroup === group;
    }

    protected getSelectedGroupData(): NProfiles.ISizeGroup | undefined {
        return this.sizeGroups.find(group => group.group === this.selectedGroup);
    }

    protected getSizeForType(typeTitle: string): number[] {
        return this.selectedSizes?.[typeTitle] || [];
    }

    protected setSizeForType(typeTitle: string, sizes: number[]): void {
        const newSizes = { ...this.selectedSizes };
        if (sizes.length > 0) {
            newSizes[typeTitle] = sizes;
        } else {
            delete newSizes[typeTitle];
        }
        this.selectedSizesChange.emit(newSizes);
    }
}
